import React from "react"
import { MathKatexBlock } from "../../../components/MathKatex"
import { ITeacherFlashcard } from "../types"

/**
 * Simple slideshow has the following slides for all vocab words:
 *  1. Word
 *  2. Step1: Introduce
 *  3. Word with pronunciation
 *  4. Step2: Define
 *  5. Definition of the word (comes from the back of the flashcard)
 *  6. Step3: Characterize
 *  7. Common uses
 *  8. Tone & Register
 *  9. Step4: Exemplify
 * 10: Correct Example Sentences
 * 11. Step5: Explore
 * 12. Class Discussion Questions
 */
export const ALL_SLIDES = [
    { component: Slide1 },
    { component: Slide2 },
    { component: Slide3, titleRight: "Step 1: Introduce"},
    { component: Slide4 },
    { component: Slide5, titleRight: "Step 2: Define" },
    { component: Slide6 },
    { component: Slide7, titleRight: "Step 3: Characterize" },
    { component: Slide8, titleRight: "Step 3: Characterize" },
    { component: Slide9 },
    { component: Slide10, titleRight: "Step 4: Exemplify"},
    { component: Slide11 },
    { component: Slide12, titleRight: "Step 5: Explore" },
]

export const NUMBER_OF_SLIDES = ALL_SLIDES.length

export function getSlide(index: number) {
    return ALL_SLIDES[index]
}

export interface ISlideProps {
    flashcard: ITeacherFlashcard
}

//--- All Presentation Slides ---

// Word
function Slide1({flashcard}: ISlideProps) {
    let {cardFront: word} = flashcard
    return (
        <div className="slide-content--fc-inner text-center">
            <h2 className="fc-h1">{word}</h2>
        </div>
    )
}

// Step1: Introduce
function Slide2({flashcard}: ISlideProps) {
    return (
        <div className="slide-content--fc-inner fc-ubar--parent align-items-center">
            <div className="fc-h3">Step 1:</div>
            <h2 className="fc-h2 fc-ubar"><span>Introduce</span></h2>
        </div>
    )
}

// Word w/pronunciation
function Slide3({flashcard}: ISlideProps) {
    let {cardFront: word, pronunciation} = flashcard
    return (
        <div className="slide-content--fc-inner text-center">
            <h2 className="fc-h1">{word}</h2>
            <h2 className="fc-h6">Pronunciation</h2>
            <h2 className="fc-h4">{pronunciation}</h2>
            <p className="fc-p"><b>• REPEAT 3 TIMES •</b></p>
        </div>
    )
}

// Step2: Define
function Slide4({flashcard}: ISlideProps) {
    return (
        <div className="slide-content--fc-inner fc-ubar--parent align-items-center">
            <div className="fc-h3">Step 2:</div>
            <h2 className="fc-h2 fc-ubar"><span>Define</span></h2>
        </div>
    )
}

// Definition of the word
function Slide5({flashcard}: ISlideProps) {
    let {details=""} = flashcard
    return (
        <div className="slide-content--fc-inner justify-content-start">
            <div className="slide-content--content fc-p">
                <MathKatexBlock mixedContent={details} />
            </div>
        </div>
    )
}

// Step3: Characterize
function Slide6({flashcard}: ISlideProps) {
    return (
        <div className="slide-content--fc-inner fc-ubar--parent align-items-center">
            <div className="fc-h3">Step 3:</div>
            <h2 className="fc-h2 fc-ubar"><span>Characterize</span></h2>
        </div>
    )
}

function Slide7({flashcard}: ISlideProps) {
    let {commonUses=""} = flashcard
    return (
        <div className="slide-content--fc-inner justify-content-start">
            <h4 className="fc-h5">Common Uses:</h4>
            <div className="slide-content--content fc-p">
                <MathKatexBlock mixedContent={commonUses} />
            </div>
        </div>
    )
}

// Tone & Register
function Slide8({flashcard}: ISlideProps) {
    let {toneAndRegister=""} = flashcard
    return (
        <div className="slide-content--fc-inner justify-content-start">
            <h4 className="fc-h5">Tone & Register:</h4>
            <div className="slide-content--content fc-p">
                <MathKatexBlock mixedContent={toneAndRegister} />
            </div>
        </div>
    )
}

// Step4: Exemplify
function Slide9({flashcard}: ISlideProps) {
    return (
        <div className="slide-content--fc-inner fc-ubar--parent align-items-center">
            <div className="fc-h3">Step 4:</div>
            <h2 className="fc-h2 fc-ubar"><span>Exemplify</span></h2>
        </div>
    )
}

// Correct Example Sentences
function Slide10({flashcard}: ISlideProps) {
    let {examples=""} = flashcard
    return (
        <div className="slide-content--fc-inner justify-content-start">
            <h4 className="fc-h5">Correct Example Sentences:</h4>
            <div className="slide-content--content fc-p">
                <MathKatexBlock mixedContent={examples} />
            </div>
        </div>
    )
}

// Step5: Explore
function Slide11({flashcard}: ISlideProps) {
    return (
        <div className="slide-content--fc-inner fc-ubar--parent align-items-center">
            <div className="fc-h3">Step 5:</div>
            <h2 className="fc-h2 fc-ubar"><span>Explore</span></h2>
        </div>
    )
}

// Class Discussion Questions
function Slide12({flashcard}: ISlideProps) {
    let {discussions=""} = flashcard
    return (
        <div className="slide-content--fc-inner justify-content-start">
            <h4 className="fc-h5">Class Discussion Questions:</h4>
            <div className="slide-content--content fc-p">
                <MathKatexBlock mixedContent={discussions} />
            </div>
        </div>
    )
}
